// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function defaultValue_setRecaptchaState(_isRecaptchaFailed) {
  
}

var defaultValue = {
  isRecaptchaFailed: false,
  setRecaptchaState: defaultValue_setRecaptchaState
};

var context = React.createContext(defaultValue);

function useRecaptchaContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useRecaptchaContext ,
}
/* context Not a pure module */
